var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPushPinBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "push_pin_black_18dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28017",
    "data-name": "Group 28017"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7930",
    "data-name": "Rectangle 7930",
    width: 20,
    height: 20,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_28018",
    "data-name": "Group 28018",
    transform: "translate(5 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16680",
    "data-name": "Path 16680",
    d: "M15,10a2.006,2.006,0,0,1-2-2V4h.5a.5.5,0,0,0,0-1h-7a.5.5,0,0,0,0,1H7V8a2.006,2.006,0,0,1-2,2v1H9.5v5.5l.5.5.5-.5V11H15ZM11.891,3.764c.48-.53-3.965.666-3.965-.1l-.082.747L11.75,4l.141,4.125A2.765,2.765,0,0,0,12.77,10Z",
    transform: "translate(-5 -3)",
    fill: "#0074b0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPushPinBlue);
export default __webpack_public_path__ + "static/media/push_pin_blue.60d2ec3e03ab4421bff8aaa54d15b2b6.svg";
export { ForwardRef as ReactComponent };